export const createAnnualEvalRootLink = (templateId: number) =>
  `/hwr/rocni-hodnoceni/${templateId}`;

export const createAdaptationPlanRootLink = (templateId: number) =>
  `/hwr/adaptacni-plan/${templateId}`;

export const createPersonalDevPlanRootLink = (templateId: number) =>
  `/hwr/plan-osobniho-rozvoje/${templateId}`;

export const createPotentialEvalRootLink = (templateId: number) =>
  `/hwr/hodnoceni-potencialu/${templateId}`;
